import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerDiscountsState } from "./types";
import { fetchPartnerDiscounts } from "./partner-discounts-thunk";
import { ErrorType } from "@/shared/types";

const initialState: PartnerDiscountsState = {
    discounts: [],
    isLoading: false,
    isFirstLoad: true,
    error: null,

    page: 1,
    limit: 50,
    totalPages: 0,
    selectedPartner: null
}

const partnerDiscountsSlice = createSlice({
    name: 'partnerDiscounts',
    initialState,
    reducers: {
        setSelectedPartner: (state, action: PayloadAction<string | null>) => {
            state.selectedPartner = action.payload
            state.page = 1
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchPartnerDiscounts.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchPartnerDiscounts.fulfilled, (state, action) => {
            state.error = null
            state.totalPages = Math.ceil(action.payload.total_count / state.limit)
            state.discounts = action.payload.items
            state.isFirstLoad = false
            state.isLoading = false
        })
        .addCase(fetchPartnerDiscounts.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload as ErrorType ?? null
        })
    },
})

export default partnerDiscountsSlice.reducer
export const { setSelectedPartner, setPage } = partnerDiscountsSlice.actions